import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class BrandRepository<BrandModel> extends RepositoryBase<BrandModel> {
    public constructor() {
        super('brandname');
    }
}
